module.exports = __webpack_public_path__ + "static/media/MBM_Logo_Vertical_Cor_RGB.1a2800cc.png";